import { BodyText, LabelText } from "@classdojo/web/nessie";
import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { Link } from "react-router-dom";

function getSrcSet(src: string) {
  if (!src) {
    return "";
  }
  return `${src} 1x, ${src.replace(".png", "@2x.png")} 2x, ${src.replace(".png", "@3x.png")} 3x`;
}

type ExperienceCardProps = {
  href: string;
  mojo: string;
  title: string;
  description: string;
};

export default function ExperienceCard({ href, mojo, title, description }: ExperienceCardProps) {
  return (
    <Link to={href} sx={experienceCardStyle}>
      <div>
        <img srcSet={getSrcSet(mojo)} src={mojo} alt="" sx={experienceCardImgStyle} />
      </div>
      <div sx={experienceCardTitleWithDescriptionStyle}>
        <LabelText as="h4" level={2}>
          {title}
        </LabelText>
        <BodyText level={2} kind="tertiary">
          {description}
        </BodyText>
      </div>
    </Link>
  );
}

const experienceCardTitleWithDescriptionStyle: ThemeUIStyleObject = {
  marginTop: RAW_cssValue("10px"),

  h4: {
    textAlign: "center",
    margin: "dt_xs",
    "@media (min-width: 375px)": {
      fontSize: "13px",
    },
  },

  span: {
    textAlign: "center",
  },
};

const experienceCardStyle: ThemeUIStyleObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  borderRadius: "dt_radius_s",
  backgroundColor: "dt_background_primary",
  border: "dt_card",
  margin: "dt_s",
  padding: "dt_l",
  textAlign: "center",
  flex: "1 1 auto",
  minWidth: "140px",
  "@media (max-width: 320px)": {
    width: "100%",
  },
  "@media (min-width: 375px)": {
    width: "158px",
  },
  "@media (min-width: 414px)": {
    width: "120px",
  },
  "@media (min-width: 768px)": {
    minWidth: "180px",
  },
};

const experienceCardImgStyle: ThemeUIStyleObject = {
  width: "100px",
  height: "100px",
  objectFit: "contain",
};
